import { render } from "./CompanyInformation.vue?vue&type=template&id=5d809f09&scoped=true"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"

import "./CompanyInformation.vue?vue&type=style&index=0&id=5d809f09&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d809f09"]])

export default __exports__